import React from 'react';
import { usePermissions } from '../contexts/PermissionsContext';

const RequireClientRole: React.FC<{
  client: string;
  role: string | string[];
  requireAny?: boolean;
  DeniedComponent?: React.FC<{
    role: string | string[];
  }>;
}> = ({ children, client, role, requireAny = false, DeniedComponent }) => {
  const { hasClientRole } = usePermissions();
  const allow = hasClientRole(client, role, requireAny);
  if (!allow) {
    if (DeniedComponent) {
      return <DeniedComponent role={role} />;
    }
    return null;
  }
  return <>{children}</>;
};

export default RequireClientRole;
